<template>
<div>
    <div class="mcc-page-header">

        <div class="mu-d-flex ">

            <h1>{{title}}</h1>
            <details class="mcc-popover mcc-popover--bottom-end">
                <summary class="mcc-button mcc-button--icon-only ">
                    <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                </summary>
                <div class="mcc-popover__content">

                    <p class="mu-mb-00">
                        {{ helpText.title }}
                        <a :href="helpText.url" target="_blank">Read more...</a>
                    </p>
                </div>
            </details>

        </div>
    </div>
    <div class="mcc-container--fluid card-padding">
       
        <nav aria-label="breadcrumb">
            <ol class="mcc-breadcrumb">
                <li>My tasks</li>
                <li>{{title}}</li>
                <li class="lastBredCrumpLi">

                </li>
            </ol>
        </nav>
      
        
        <div class="mcc-row" v-if="!fetchCall">
            <div class="mcc-col colSpinner">
                <div class="spinner-overlay">
                    <div class="spinner-background"></div>
                    <div class="spinner-flex">
                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>

            </div>

        </div>
        <div class="mcc-row" v-show="fetchCall">
            <div class="mcc-col">
                <div class="mcc-card">
                    
                    <div class="mcc-card__body">
                        <mcc-alert role="alert" class="mcc-alert mcc-alert--info mcc-alert--compact" v-if="showNoRecords" color="info">
                            <mcc-icon name="info" aria-hidden="true"></mcc-icon>
                            <p>No drafts found</p>

                            <button class="mcc-button mcc-button--info mcc-button--sm mcc-button--icon-only" style="margin-inline-start: auto">
                                <mcc-icon name="close" icon-set="fluency-outline" aria-hidden="true"></mcc-icon>
                                <span class="mcc-button__label">Button</span>
                            </button>
                        </mcc-alert>
                        <div class="mcc-row"  v-show="showProcesses">
                            <div class="mcc-col">
                                <div class="mu-bg-container-grouping mu-pb-05 mu-radius-top">
                                    <div class="mfc-input-wrapper">
                                        <div class="mfc-input-group mfc-input-group--leading-icon">
                                            <mcc-icon class="mfc-input-group__icon mu-mt-02" name="search" aria-hidden="true"></mcc-icon>
                                            <input id="list-group-filter" name="list-group-filter" type="text" placeholder="Type to search...">
                                        </div>
                                    </div>
                                </div>
                                <ul class="mcc-list-group">
                                    <li v-for="(app,key) in processList" :key="key" class="mcc-list-group-li">

                                        <details class="mcc-collapse mu-w-100" @click="handleExpand(key)" :id="'collapseTasks' + key">
                                            <summary>
                                                <div class="mcc-menu__button">
                                                    <mcc-icon class="mcc-icon--advanced mu-mr-03" v-if="app.iconSet == ''" :name="app.processLogo"></mcc-icon>
                                                    <mcc-icon class="mu-mr-03" v-if="app.iconSet != ''" :name="app.processLogo" icon-set="fluency-color"></mcc-icon>
                                                    {{app.defName}}

                                                </div>
                                                <span class="mcc-chip  mcc-chip--xs mcc-chip--info mu-mr-04">{{app.numberOfProcesses}}</span>
                                                <mcc-icon class="mcc-button__dropdown-caret" name="expand_arrow" aria-hidden="true"></mcc-icon>

                                            </summary>
                                            <div class="mcc-collapse-body mu-mt-03">
                                                <mcc-data-table ref="myTable" :id="'myTable'+key"></mcc-data-table>
                                            </div>
                                        </details>

                                    </li>
                                </ul>
                            </div>

                        </div>

                    </div>
                </div>
                </div>

            </div>

        </div>
   
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--danger mcc-dialog--xs" color="danger" ref="deleteEntityModal" id="deleteEntityModal">
            <section>
                <div class="mcc-dialog__header">
                    <h2 class="h4">Delete draft</h2>
                    <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.deleteEntityModal.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                </div>
                <div class="mcc-dialog__body">
                    <div class="mcc-row">
                        <div class="mcc-col">
                            {{removeDraftMsg}}?

                        </div>

                    </div>
                </div>
                <div class="mcc-dialog__footer">

                    <div class="mcc-button-group mcc-button-group--spaced">
                        <button type="button" class="mcc-button mcc-button--outline" @click="$refs.deleteEntityModal.close()">No</button>
                        <button type="submit" class="mcc-button mcc-button--danger" @click="handleDeleteDraftDialogClose($event)">Yes</button>
                    </div>
                </div>
            </section>
        </dialog>
    </div>
</div>
</template>

<script>
import constantMessages from "../../messages";
import Table from "@advanced/component-mosaic-table";
import MyTaskListAPI from "../../services/MyTaskListAPI";
import Utils from "@/script_utils";
import {
    EventBus
} from '../../services/event-bus';
export default {
    name: "DraftTaskList",
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["mytasks.draftTasks"],
            showProcesses: false,
            fetchCall: false,
            processList: [],
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            tableObj: [],
            currentPageSize: [],
            title: "Drafts",
            updateCallTable: false,
            removeDraftMsg: "",
            removeDraftId: "",
            removeDraftProcessName: "",
            showNoRecords: false,
            tableData: [],
            filterActive: false,
            filterData: [],
            filterCount: 0,
        };
    },
    created() {},
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);
        this.updateProcessData();
        const listGroupFilter = document.querySelector('input#list-group-filter')

        listGroupFilter.addEventListener('input', (event) => {
            this.filterItems(event)
        })

    },
    methods: {
        filterItems(event) {
            const listGroupComponent = document.querySelector('.mcc-list-group')
            window.filterTimeout && clearTimeout(window.filterTimeout)

            window.filterTimeout = setTimeout(() => {
                const filter = event.target.value.toLowerCase()
                const items = listGroupComponent.querySelectorAll('li')

                // clear previous filter and apply new
                items.forEach(item => item.classList.remove('mu-d-none'))
                items.forEach(item => {
                    if (!item.innerText.toLowerCase().includes(filter)) item.classList.add('mu-d-none')
                })
            }, 250)
        },
        updateProcessData() {
            var self = this;
            self.showProcesses = false;
            self.showNoRecords = false;
            self.fetchCall = false;
            self.tableObj = [];
            self.processList = [];
            var queryString = "forTask=true";
            MyTaskListAPI.getDraftProcesses(queryString).then(result => {
                self.processList = result;
                if (result.length > 0) {
                    self.showProcesses = true;
                    Utils.loadProcessLogoInList(self.processList);
                } else {
                    self.showNoRecords = true;
                }
            }).finally(() => {
                self.fetchCall = true;
            });
        },
        handleExpand(key) {
            this.updateCallTable = true;
            this.initDraftTable(key);
        },
        initDraftTable(key) {
            var self = this;
            if (this.tableObj[key] == null) {
                self.updateCallTable = false;
                if (self.currentPageSize[key] == null) {
                    self.currentPageSize[key] = 10;
                }
                const filesTable = document.querySelector('#myTable' + key);
                if (filesTable) {
                    this.tableObj[key] =  window.tableFactory.create(filesTable, {
                        bordered: true,
                        striped: true,
                        fixedHeight: true,
                        dateFormat: "DD-MMM-YYYY",
                        pageSize: 10,
                        schema: {
                            properties: {
                                name: {
                                    type: "string",
                                    title: "Draft name",
                                    template: '<a class="name-link" data-id="{{taskId}}">{{name}}</a>',
                                    sortable: true,
                                    columnSearch: false
                                },
                                taskName: {
                                    type: "string",
                                    title: "Task name",
                                    sortable: true,
                                    columnSearch: false
                                },
                                prettyCreatedTime: {
                                    type: "string",
                                    title: "Created",
                                    template: '<div class="dateTemplate"><u>{{prettyCreatedTime}}</u><div>{{createTimeObject}}</div></div>',
                                    sortable: true,
                                    columnSearch: false
                                },
                                createdBy: {
                                    type: "string",
                                    title: "Created by",
                                    sortable: true,
                                    columnSearch: false
                                },
                                prettyLastUpdatedTime: {
                                    type: "string",
                                    title: "Last updated",
                                    template: '<div class="dateTemplate"><u>{{prettyLastUpdatedTime}}</u><div>{{lastUpdatedTimeObject}}</div></div>',
                                    sortable: true,
                                    columnSearch: false
                                },
                                lastUpdatedBy: {
                                    type: "string",
                                    title: "Last updated by",
                                    sortable: true,
                                    columnSearch: false
                                },
                                actions: {
                                    type: "object",
                                    title: "Actions",
                                    properties: {
                                        "deleteAction": {
                                            type: "string",
                                            title: "DeleteButton",
                                            format: "button",
                                            icon: "trash",
                                            color: "danger",
                                            iconOnly: true
                                        }
                                    }
                                }

                            }
                        },

                        data: (
                            start,
                            limit,
                            sortHeader,
                            sortDirection,
                            fullTextQuery,
                            searchColumns
                        ) => {
                            if (!self.filterActive) {
                                self.updateCallTable = false;
                                if (self.tableObj[key] != null) {
                                    self.currentPageSize[key] =
                                        self.tableObj[key].tableContext.store.state.pageSize;
                                }
                                var sortHeaderData = sortHeader == null ? "created" : sortHeader;
                                var sortDir = sortDirection == null ? "desc" : sortDirection;
                                if (sortHeaderData == "prettyCreatedTime") {
                                    sortHeaderData = "created";
                                } else if (sortHeaderData == "prettyLastUpdatedTime") {
                                    sortHeaderData = "lastUpdated";
                                }
                                var queryString =
                                    "start=" +
                                    start +
                                    "&length=" +
                                    self.currentPageSize[key] +
                                    "&processDefinitionName=" +
                                    self.processList[key].defName +
                                    "&sort=" +
                                    sortHeaderData + "," +
                                    sortDir + "&forTask=true";

                                return MyTaskListAPI.getDraftsData(queryString).then(result => {
                                    var responseData = {
                                        totalCount: 0,
                                        data: []
                                    };
                                    responseData.totalCount = result.page.totalElements;
                                    if (result.data != null) {
                                        result.data.forEach(element => {

                                            element['createTimeObject'] = (element.created != null) ?
                                                Utils.getMomentDateString(element.created) : '';

                                            element['lastUpdatedTimeObject'] = (element.lastUpdated != null) ?
                                                Utils.getMomentDateString(element.lastUpdated) : '';

                                            element['prettyCreatedTime'] = element['prettyCreatedTime'] == null ? "" :
                                                element['prettyCreatedTime'];

                                            element['prettyLastUpdatedTime'] = element['prettyLastUpdatedTime'] == null ? "" :
                                                element['prettyLastUpdatedTime'];

                                        });
                                        responseData.data = result.data;
                                        self.tableData = responseData.data;
                                    }
                                    self.updateCallTable = true;
                                    return responseData;
                                });
                            } else {
                                self.filterActive = false;
                                let responseData = {
                                    totalCount: self.filterData.length,
                                    data: self.filterData
                                };
                                return responseData;
                            }
                        },
                        onAction: (table, action, obj) => {
                            let rowData = obj[0].rowData;
                            if (action == "deleteAction") {
                                self.removeDraftMsg = "";
                                self.removeDraftId = "";
                                self.removeDraftProcessName = "";
                                if (rowData.name != null && rowData.name != "") {
                                    self.removeDraftMsg = "Are you sure you want to delete draft : " + rowData.name + " ";
                                } else {
                                    self.removeDraftMsg = "Are you sure you want to delete draft ";
                                }
                                self.removeDraftId = rowData.id;
                                self.removeDraftProcessName = rowData.processDefinitionName;
                                self.$refs.deleteEntityModal.show();
                            }
                        },
                        onAfterDataLoad: (start, limit) => {
                            self.updateTemplate(key);
                        }

                    });

                }

            }
        },
        handleDeleteDraftDialogClose(e) {
            var self = this;
            this.$refs.deleteEntityModal.close()
            if (this.removeDraftId) {
                MyTaskListAPI.deleteDraft(this.removeDraftId).then(result => {
                    EventBus.$emit('success-notification', {
                        "msg": constantMessages.MESSAGES[result]
                    });
                    self.updateProcessData();
                });
            }
        },
        updateTemplate(key) {
            var self = this;
            this.$refs.myTable[key]
                .querySelectorAll('td [class="name-link"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        var targetEle = e.target;
                        if (targetEle != null) {
                            var reference = $(targetEle).attr("data-id");
                            self.$router.push(
                                self.CONTEXT_PATH + "/tasks/viewtask/" + self.title.toLowerCase() + "/" + reference.trim()
                            );
                        }
                    });
                });
        },
    }
};
</script>

<style scoped>
.mc-card-deck .mc-card {
    height: 120px;
    margin-left: 0;
    margin-right: 0;
}

.mc-list-group mosaic-badge {
    display: flex;
    flex: 1;
    justify-content: flex-end;
}

.mcc-list-group-li {
    border-bottom: 1px solid #666679;
}

.mcc-list-group {
    border-top: 1px solid #666679;
    border-left: 1px solid #666679;
    border-right: 1px solid #666679;
}
</style>
